<template lang="pug">
  div
    template(
      v-if="loaded")
      v-card.mb-2(
        v-for="item in animalTypes"
        :key="item.id")
        .list-mobile
          .list-mobile__top
            .list-mobile__title.list-mobile__title--size-lg {{ item.name | shortstr }}
            .list-mobile__button
            v-btn(
              :disabled="isConsultant"
              icon
              @click="selectAnimalType(item.id)")
              v-icon(
                font-size="1"
                icon="cog")
          .list-mobile__content
            .list-mobile__item
              .list-mobile__item-label {{ 'base.animal_count' | translate }}
              .list-mobile__item-value {{ item.animal_count || 0 }}

      v-table-body(
        v-if="loaded"
        outsideTable
        :empty="!animalTypes.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 1" :key="`${i}-${j}`")
              .list-mobile__item-skeleton
              .list-mobile__item-skeleton

    template(
      v-if="loaded && animalTypes.length")
      ui-pagination(
        v-model="page"
        offset-none
        :count="count"
        @page-change="loadData")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'TypesTableMobile',

  components: {
    UiPagination
  },

  data: () => ({
    page: 1,
    loaded: false
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'count'
    ])
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('animaltypes', [
      'loadAnimalTypes',
      'selectAnimalType'
    ]),

    async loadData () {
      const filters = {
        farm: this.$route.params.farm_id,
        page: this.page > 1 ? this.page : null
      }
      await this.loadAnimalTypes(filters)
      this.loaded = true
    }
  },

  watch: {
    page () {
      this.loaded = false
    }
  }
}
</script>
